/**
 * Intel to Influence page (build placeholder).
 *
 * Re-points the /intel route to an honest "in build" shell. The prior /intel
 * surface (src/pages/Intel.tsx, a v0.7 index.html port with sample skeletons
 * and disabled controls) is preserved on disk but no longer routed (hide, do
 * not delete). No feature logic, data access, or controls live here yet — a
 * deliberate honest placeholder, not a broken page. The real surface lands in a
 * later phase once its sealed design is sequenced for build. Reuses the shared
 * page-header and card-surface classes (no new CSS).
 */
export function IntelToInfluence() {
  return (
    <div>
      <header className="bdse-page-header">
        <h1 className="bdse-page-title">Intel to Influence</h1>
        <p className="bdse-page-subtitle">
          Market intelligence and thought leadership
        </p>
      </header>

      <div className="bdse-glass-surface p-8 max-w-3xl">
        <p className="text-sm text-bdse-text-secondary leading-relaxed">
          This surface is in build. Design is sealed and the build is sequenced.
        </p>
      </div>
    </div>
  );
}
